/**
 * Maps a Rails `access_restricted_reason` code to a human-readable explanation,
 * so tools can tell the user why they get no results. Rails does the enforcing.
 */

import { Credentials } from "./credentials.js";

const REASON_MESSAGES: Record<string, string> = {
  mcp_login_disabled:
    "MCP access via login is disabled for this organization. An admin can enable it in zeroheight under organization settings → MCP.",
  no_styleguides_enabled:
    "No styleguides in this organization have MCP access via login enabled. An admin can enable access in each styleguide's MCP settings.",
  viewer_no_access:
    "Your account doesn't have MCP access to any styleguides in this organization. Contact an admin if you expect access.",
};

const FALLBACK_MESSAGE =
  "MCP access is currently restricted for this organization. Contact an admin if you expect access.";

export function accessRestrictedMessage(
  credentials: Credentials,
): string | undefined {
  if (credentials.type !== "oauth_jwt" || !credentials.accessRestrictedReason) {
    return undefined;
  }

  return (
    REASON_MESSAGES[credentials.accessRestrictedReason] ?? FALLBACK_MESSAGE
  );
}
